/*
 * Homepage background videos (snippets/home-video.liquid, [data-home-video]).
 * Plays each video while it is near the viewport and pauses it when it leaves,
 * so below-the-fold footage only downloads when the visitor gets close. Under
 * prefers-reduced-motion nothing plays and the poster stays.
 * Safe to load from several sections: it runs once.
 */
(function () {
  if (window.__homeMediaInit) return;
  window.__homeMediaInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function videos() {
    return Array.prototype.slice.call(document.querySelectorAll('video[data-home-video]'));
  }

  function play(video) {
    if (reduce && reduce.matches) return;
    if (video.preload === 'none') video.preload = 'auto';
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var list = videos();
    if (reduce && reduce.matches) {
      list.forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      list.forEach(play);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { rootMargin: '300px 0px' });

    list.forEach(function (v) { io.observe(v); });
  }

  if (reduce && reduce.addEventListener) {
    reduce.addEventListener('change', function () {
      videos().forEach(function (v) {
        if (reduce.matches) v.pause();
        else play(v);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
